import { useQuery } from "react-query";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { OlapScoresQuery } from "src/context/OlapScores/useOlapScoresParams";
import { OlapScoresWithPrevScoresSchema } from "./olapScoresSchema";

export const getIngredientScoresKey = "getIngredientScores" as const;

type Options = {
    ingredientId: number | undefined;
    campaignId: number | undefined;
    companyId: number | undefined;
    scoresQuery?: OlapScoresQuery;
    enabled?: boolean;
};

export const useGetIngredientScores = (options: Options) => {
    const { ingredientId, campaignId, companyId, scoresQuery, enabled = true } = options;

    return useQuery({
        queryKey: [getIngredientScoresKey, ingredientId, companyId, campaignId, scoresQuery],
        enabled: enabled && !!ingredientId && campaignId !== undefined,
        staleTime: 5 * 60 * 1000,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        queryFn: async () => {
            const url = `/api/ingredients/${ingredientId}/campaign/${campaignId}/scores`;

            return await loggedInApiCall.get(url, {
                params: {
                    ...scoresQuery,
                    organization_id: companyId,
                },
            });
        },
        select: (request) => {
            const data = zodParseWithDetailedLog(request.data, OlapScoresWithPrevScoresSchema, {
                operation: "GET",
                endpoint: "/ingredients/:id/campaign/:campaignId/scores",
            });
            return data;
        },
    });
};
